import {BaseMuWidget} from "./BaseMuWidget";
import {BaseRouter} from "./BaseRouter";

export class TopPage extends BaseMuWidget {
    public router: BaseRouter = new BaseRouter();
}